import { DateTimeModel } from "../DateTimeModel";
export class PerformReviewModel{
    id:number;
    description:string;
    newDailyHours:number;
    nextReviewDate?:string;
    nextReviewDateComponent:DateTimeModel;
}